import { FlexBox } from '@Backlot-Cars/archie';
import styled from 'styled-components';

export const ReviewContent = styled(FlexBox).attrs({ flexDirection: 'column', width: '100%' })``;

export const ReviewHeader = styled(FlexBox).attrs({ flexDirection: 'column', gap: 'md' })``;

export const ReviewHeaderRow = styled(FlexBox).attrs({ alignItems: 'center', gap: 'xs' })``;

export const ReviewSection = styled(FlexBox).attrs({
	borderBottomWidth: 1,
	borderColor: 'primary',
	flexDirection: 'column',
	gap: 'lg',
	padding: ['xl', 0],
})``;

export const ReviewPolicies = styled(FlexBox).attrs({ flexDirection: 'column', gap: 'md', padding: ['xl', 0] })``;

export const ReviewActions = styled(FlexBox).attrs({
	alignItems: 'center',
	flexDirection: 'row-reverse',
	gap: 'sm',
	justifyContent: 'space-between',
	width: '100%',
})``;
